import moment from 'moment';

export const generateDaysArrayFromRange = (dateRange: Date[]) => {
    const dateTimeDifference = dateRange[1].getTime() - dateRange[0].getTime();
    const dayInMilliseconds = 1000 * 60 * 60 * 24;
    const daysDifference = Math.ceil(dateTimeDifference / dayInMilliseconds) + 1; // +1 to include the last day

    return Array.from({ length: daysDifference }, (_, index) => moment(dateRange[0]).add(index, 'days').toDate());
};
